import { css } from '@emotion/react';
import { Stack, styled } from '@mui/joy';

export const CardHeader = styled(Stack)(
  ({ theme }) => css`
    padding: ${theme.spacing(2)} ${theme.spacing(4)};
    height: 56px;
    color: ${theme.palette.neutral.softColor};
    background-color: ${theme.palette.neutral.softBg};
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    border-top-left-radius: ${theme.radius.xl};
    border-top-right-radius: ${theme.radius.xl};
    --ModalClose-inset: ${theme.spacing(1.5)};
  `,
);

CardHeader.defaultProps = {
  direction: 'row',
  alignItems: 'center',
};
